import React, { useEffect, useRef } from "react";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { finishApplication, cancelApplication } from "../../actions";
import { selectedOfferSelector, userInfoSelector, appRequestSelector, trendingsVisitID, acimaConfigSelector } from "../../selectors";
import { tokenSelector } from "containers/EmbeddableWidget/selectors";
import { closeModal } from "containers/MultistepModal/actions";
import { AnalyticAPI } from "api/analytic";
import { ProvidersApi } from "api/providers";
import "./../Frame/styles.scss";

const AcimaContract = ({
  selectedOffer,
  appRequest,
  hidden,
  token,
  visitID,
  acimaConfig,
  finishApplication,
  cancelApplication,
  closeModal,
}) => {
  const completedRef = useRef(false);

  useEffect(() => {
    if (typeof window.Acima === "undefined" || !window.Acima.Client) {
      finishApplication({ status: "exited" });
      return;
    }

    if (!acimaConfig || !acimaConfig.location_guid) {
      console.error("[acima] missing config — BE did not return location_guid");
      finishApplication({ status: "exited" });
      return;
    }

    const userInfo = appRequest.personalInfo || {};
    const address = appRequest.residenceInfo || {};

    const customerAddress = {
      street1: address.street || "",
      street2: address.street2 || "",
      city: address.city || "",
      state: address.state || "",
      zipCode: address.zip || "",
    };

    const buildCheckoutOptions = (authToken) => {
      const options = {
        transaction: selectedOffer.transaction_data,
        customer: {
          firstName: userInfo.firstName,
          middleName: "",
          lastName: userInfo.lastName,
          phone: userInfo.phone,
          email: userInfo.email,
          address: customerAddress,
        },
        billingAddress: customerAddress,
        shippingAddress: customerAddress,
        onClose: () => {
          if (!completedRef.current) {
            cancelApplication();
            closeModal();
          }
        },
        onPageTransition: ({ page }) => {
          if (page && token) {
            AnalyticAPI.send_provider_analytic_event(
              token,
              `acima_page_${page}`,
              "acima",
              visitID
            );
          }
        },
      };

      if (selectedOffer.lease_app_id) {
        options.contractId = selectedOffer.lease_app_id;
      }
      if (authToken) {
        options.authToken = authToken;
      }
      return options;
    };

    const openIframe = (authToken) => {
      const client = new window.Acima.Client({
        merchantId: acimaConfig.location_guid,
        iframeUrl: acimaConfig.iframe_url,
        iframeContainer: document.getElementById("acima-iframe-container"),
      });

      client
        .checkout(buildCheckoutOptions(authToken))
        .then((response) => {
          completedRef.current = true;
          finishApplication({
            leaseId: response?.leaseId,
            leaseNumber: response?.leaseNumber,
            checkoutToken: response?.checkoutToken,
          });
        })
        .catch((error) => {
          const message = error?.message || "acima checkout failed";
          console.error("[acima]", message);
          if (!completedRef.current) {
            cancelApplication();
          }
        });
    };

    const canBypassOtp = selectedOffer.lease_app_id && userInfo.phone;
    if (canBypassOtp) {
      ProvidersApi.acimaSessionToken(token, {
        app_id: selectedOffer.app_id,
        phoneNumber: userInfo.phone,
      })
        .then((data) => openIframe(data && data.token))
        .catch((err) => {
          console.warn("[acima] session_token fetch failed, opening iframe without OTP bypass", err);
          openIframe(null);
        });
    } else {
      openIframe(null);
    }
  }, []);

  return (
    <div style={{ display: hidden ? "none" : "inherit" }}>
      <div id="acima-iframe-container"></div>
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  userInfo: userInfoSelector(),
  selectedOffer: selectedOfferSelector(),
  appRequest: appRequestSelector(),
  token: tokenSelector(),
  visitID: trendingsVisitID(),
  acimaConfig: acimaConfigSelector(),
});

const mapDispatchToProps = (dispatch) => ({
  finishApplication: (values) => dispatch(finishApplication(values)),
  cancelApplication: (values) => dispatch(cancelApplication(values)),
  closeModal: () => dispatch(closeModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AcimaContract);
